<template>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"
         x="0" y="0" viewBox="0 0 384 384"
         :width="size ? size : 512" :height="size ? size : 512"
         :class="[color]">
         xml:space="preserve" class="">
        <g>
            <path xmlns="http://www.w3.org/2000/svg" d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path>
            <path xmlns="http://www.w3.org/2000/svg" d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path>
            <path xmlns="http://www.w3.org/2000/svg" d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path></g>
    </svg>
</template>

<script>
export default {
    name: "IconMenu",
    props: ['color', 'size'],
}
</script>

<style lang="scss" scoped>
path{fill:white}

.dark{
    path{
        fill:#4a4a5a;
    }
}
</style>
